import { DurabilityTaxonomy } from '../../../../types';
export var list = [
    DurabilityTaxonomy.YES,
    DurabilityTaxonomy.NO,
];
